import { Auth } from "@/service/auth/authService";
import Database from "@/service/database/databaseService";

import router from "@/router";

import { useToast } from "vue-toastification";

const toast = useToast();

const state = {
    user: {},
    userLoggedIn: false,
}

const mutations = {
    storeUser(state, payload) {
        state.user = payload;
        state.userLoggedIn = true;
        localStorage.setItem('kanban-auth-token', payload.accessToken);
        Database.init(payload.uid);
    }
}

const actions = {
    async signUpUser({ commit }, auth) {
        let res = await Auth.signUp(auth.email, auth.password)
        let user = res.user;
        if (user?.accessToken) {
            await Database.addUser(user.uid);
            commit('storeUser', user);
            router.push('/');
        }
        toast[res.status](res.message)
    },

    async signInUser({ commit }, auth) {
        let res = await Auth.signIn(auth.email, auth.password);
        let user = res.user;
        if (user?.accessToken) {
            commit('storeUser', user);
            router.push('/');
        }
        toast[res.status](res.message)
    },
}

const namespaced = true

const auth = {
    state,
    mutations,
    actions,
    namespaced
}

export default auth;